/**
 * /organic-plan — strona pricingu planu Organic z interaktywnym konfiguratorem.
 * onSelect → Stripe Checkout (vertical content_creation, tier start = plan Organic).
 */
import { apiRequest } from "@/lib/queryClient";
import { useToast } from "@/hooks/use-toast";
import OrganicPlanBuilder from "@/components/organic/OrganicPlanBuilder";

export default function OrganicPlanPage() {
  const { toast } = useToast();

  const startCheckout = async (cycle: "monthly" | "yearly") => {
    try {
      const data = (await apiRequest("POST", "/api/billing/create-checkout", {
        vertical: "content_creation",
        tier: "start",
        cycle,
      })) as { url?: string };
      if (data?.url) {
        window.location.href = data.url;
        return;
      }
      throw new Error("Brak URL Stripe Checkout");
    } catch (err) {
      toast({
        title: "Nie udało się otworzyć płatności",
        description: err instanceof Error ? err.message : "Spróbuj ponownie.",
        variant: "destructive",
      });
    }
  };

  return (
    <div className="min-h-screen bg-background text-white">
      <div className="max-w-6xl mx-auto px-6 py-12">
        <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight mb-2">
          Znajdź plan dla siebie
        </h1>
        <p className="text-white/50 mb-8">
          Zaznacz co chcesz tworzyć i zobacz ile tokenów realnie zużyjesz
        </p>
        <OrganicPlanBuilder onSelect={(cycle) => startCheckout(cycle)} />
      </div>
    </div>
  );
}
